export class ProductSizeGuide extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.expanded = false
    this.hiddenRows = this.els.row.elements
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els.toggle?.exists) return

    this.handleToggle = this.handleToggle.bind(this)
    this.listeners.add(this.els.toggle.element, 'click', this.handleToggle)
  }

  handleToggle () {
    this.expanded = !this.expanded

    this.hiddenRows.forEach((row) => {
      row.style.display = this.expanded ? '' : 'none'
    })

    if (!this.expanded) {
      this.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }

    this.els.toggle.element.setAttribute('aria-expanded', this.expanded)
    this.els.toggle.element.innerHTML = this.expanded
      ? this.lessHTML
      : this.moreHTML
  }

  get moreHTML () {
    return `${this.dataset.labelMore} <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M13 11h5v2h-5v5h-2v-5H6v-2h5V6h2z"/></svg>`
  }

  get lessHTML () {
    return `${this.dataset.labelLess} <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M18 13H6v-2h12z"/></svg>`
  }
}

if (!customElements.get('product-size-guide')) {
  customElements.define('product-size-guide', ProductSizeGuide)
}
